import { get, put } from "@beatbox/voice-core";
const KEY = "custom-phonemes";
const HIDDEN_KEY = "hidden-presets";
const OVERRIDES_KEY = "preset-overrides";
export async function loadCustomPhonemes() {
    const saved = await get("prefs", KEY);
    return Array.isArray(saved) ? saved : [];
}
export async function saveCustomPhonemes(phonemes) {
    await put("prefs", KEY, phonemes);
    console.info(`[phonemes] persisted ${phonemes.length} custom phoneme(s)`);
}
export async function loadHiddenPresets() {
    const saved = await get("prefs", HIDDEN_KEY);
    return Array.isArray(saved) ? saved : [];
}
export async function saveHiddenPresets(ids) {
    await put("prefs", HIDDEN_KEY, ids);
    console.info(`[phonemes] persisted ${ids.length} hidden preset(s)`);
}
export async function loadTrainedPhonemes() {
    const { getActiveLibraryId, refreshTrainedFlags } = await import("./libraries.js");
    const id = await getActiveLibraryId();
    const lib = await refreshTrainedFlags(id);
    return lib.phonemes;
}
export async function markPhonemeTrained(id, trained = true) {
    const { markPhonemeTrainedInActive } = await import("./libraries.js");
    await markPhonemeTrainedInActive(id, trained);
}
export async function loadPresetOverrides() {
    const saved = await get("prefs", OVERRIDES_KEY);
    return saved && typeof saved === "object" ? saved : {};
}
export async function savePresetOverrides(overrides) {
    await put("prefs", OVERRIDES_KEY, overrides);
    console.info(`[phonemes] persisted ${Object.keys(overrides).length} ` +
        `preset override(s)`);
}
export function exportLibrary(custom, hiddenPresets, presetOverrides = {}) {
    const lib = {
        version: 1,
        custom,
        hiddenPresets,
        presetOverrides,
    };
    return JSON.stringify(lib, null, 2);
}
export function parseLibrary(json) {
    const parsed = JSON.parse(json);
    const sanitize = (c) => ({
        id: (c.id ?? "")
            .trim()
            .toLowerCase()
            .replace(/[^a-z0-9_-]/g, ""),
        label: (c.label ?? "").trim() || (c.id ?? "").trim(),
        icon: (c.icon ?? "").trim() || "❓",
        percussive: !!c.percussive,
        pitchInvariant: c.pitchInvariant ?? true,
    });
    if (Array.isArray(parsed)) {
        return {
            version: 1,
            custom: parsed.map(sanitize),
            hiddenPresets: [],
            presetOverrides: {},
        };
    }
    const custom = Array.isArray(parsed.custom) ? parsed.custom : [];
    const hiddenPresets = Array.isArray(parsed.hiddenPresets)
        ? parsed.hiddenPresets
        : [];
    return {
        version: parsed.version ?? 1,
        custom: custom.map(sanitize),
        hiddenPresets,
        presetOverrides: parsed.presetOverrides && typeof parsed.presetOverrides === "object"
            ? parsed.presetOverrides
            : {},
    };
}
